import { EPageRole, EPageType, IPageConfigByRole, IPageConfigByType } from './types';

export const PAGES_CONFIG_BY_TYPE: Record<EPageType, IPageConfigByType> = {
  [EPageType.PROPERTY]: {
    defaultSubheadline: 'Property Portal',
  },
  [EPageType.AREA]: {
    defaultSubheadline: 'Destination Spotlight',
  },
  [EPageType.ACTIVITY]: {
    defaultSubheadline: 'Experiences & Adventures',
  },
  [EPageType.MISC]: {
    defaultSubheadline: 'Itinerary Details',
  },
  [EPageType.ABOUT_US]: {
    defaultSubheadline: 'A Personal Touch',
  },
  [EPageType.ABOUT_SAFARI]: {
    defaultSubheadline: 'A Note About Your Itinerary',
  },
  [EPageType.PRE_TRAVEL_INFO]: {
    defaultSubheadline: 'Prepare For Your Trip',
  },
  [EPageType.DAY]: {
    disabledAddingBlocks: true,
  },
};

export const PAGES_CONFIG_BY_ROLE: Record<EPageRole, IPageConfigByRole> = {
  [EPageRole.COVER_PAGE]: {
    disabledAddingBlocks: true,
    hiddenStickyHeader: true,
    centeredContent: true,
    isTextOverImageEditable: false,
    defaultSubheadline: 'Prepared For You',
  },
  [EPageRole.SAFARI_MAP]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.SAFARI_OVERVIEW]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.SAFARI_COSTS]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
    defaultSubheadline: 'The Fine Print',
  },
  [EPageRole.TERMS]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.ABOUT_US]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.ABOUT_SAFARI]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.DETAILS]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.GUESTS]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.SAFARI_MANIFEST]: {
    disabledAddingBlocks: true,
  },
  [EPageRole.TRAVEL_BRIEF]: {
    disabledAddingBlocks: false,
    isTextOverImageEditable: true,
  },
  [EPageRole.TRAVEL_WALLET]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.COMMON]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.COMMON_PAGES_FIRST]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.COMMON_PAGES_SECOND]: {
    isTextOverImageEditable: true,
  },
  [EPageRole.RELOCATIONS]: {
    disabledAddingBlocks: true,
    isTextOverImageEditable: true,
  },
  [EPageRole.DAY]: {
    isTextOverImageEditable: false,
  },
};
